import BaseProxy from './Proxy';

export default class InitProxy extends BaseProxy {
  constructor(sessionId) {
    super('api');
    this.initParameters = { initType: 'init', sessionId, path: location.pathname };
    this.reInitParameters = { initType: 'reInit', sessionId, path: location.pathname };
  }

  init() {
    return this.submit('post', `${this.endpoint}/init`, this.initParameters);
  }

  reInit() {
    return this.submit('post', `${this.endpoint}/init`, this.reInitParameters);
  }
}
